import {createContext, useContext} from "react"

export const ThemeContext = createContext();

const fixedThemeState = {primary: 'fixed-theme', background: 'fixed-theme'}

export const ThemeProvider = ({children}) => {
    const themeHandler = () => {
        console.log('Theme is fixed and cannot be changed');
    }

    return <ThemeContext.Provider value={{themeState: fixedThemeState, themeHandler}}>{children}</ThemeContext.Provider>
}

// custom hook to use our theme context wherever we want in our project
export const useThemeContext = () => {
    return useContext(ThemeContext);
}